import api from 'api'

type DeleteRateRequest = {
  ruleId: number
  rateId: number
}

export const deleteRate = async (request: DeleteRateRequest): Promise<void> => {
  await api.delete(
    `/admin/wage/rules/${request.ruleId}/rates/${request.rateId}`
  )
}
